import { Application } from '@/types/application';
import { BackendApplication } from '@/types/backend';
import { emptyApplication } from '@/util/application';
import { createContext } from 'react';

/**
 * Pass a function when the update builds on existing state. A value built during render starts from
 * that render's application, so it discards anything else updated from the same change.
 */
export type ApplicationUpdate = Application | ((previous: Application) => Application) | undefined;

type ApplicationContextType = {
  application: Application;
  setApplication: (newApplication: ApplicationUpdate, isNewApplication?: boolean) => void;
  hasUnsavedChanges: boolean;
  setHasUnsavedChanges: (hasUnsavedChanges: boolean) => void;
  backendApplication: BackendApplication | undefined;
  setBackendApplication: (backendApplication: BackendApplication | undefined) => void;
};

export const ApplicationContext = createContext<ApplicationContextType>({
  application: emptyApplication,
  setApplication: () => {},
  hasUnsavedChanges: false,
  setHasUnsavedChanges: () => {},
  backendApplication: undefined,
  setBackendApplication: () => {}
});
